import { render, staticRenderFns } from "./LoginBanner.vue?vue&type=template&id=52d2b0a5&scoped=true&"
import script from "./LoginBanner.vue?vue&type=script&lang=js&"
export * from "./LoginBanner.vue?vue&type=script&lang=js&"
import style0 from "styles/views/login/loginbanner.css?vue&type=style&index=0&id=52d2b0a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2b0a5",
  null
  
)

export default component.exports